import { render } from "./RelatorioAnaliseDesconto.vue?vue&type=template&id=40f86e1a&ts=true"
import script from "./RelatorioAnaliseDesconto.vue?vue&type=script&lang=ts"
export * from "./RelatorioAnaliseDesconto.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__